/**
 * Production environment configuration
 */
import type { Config } from './default';

const config: Partial<Config> = {
  descope: {
    // Production environment
    pharmacyPortal: {
      flowId: 'sign-in-pharmacist',
      tenant: '',
    },
    projectId: 'P2noK0F7DnscERByPzXZw5g5gfKX',
  },
  statsig: {
    // Client-side SDK key for development environment
    sdkKey: 'client-ktoUtBZNFH8cDmuTEIe7cQdzH0qdmaIkYptw8ALMHyZ',
    environment: 'production',
  },
  isProduction: true,
};

export default config;
